(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const formatNumber = (value, decimals) =>
    value.toLocaleString('it-IT', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });

  const countUp = (el) => {
    const to = parseFloat(el.dataset.kvCount);
    const from = parseFloat(el.dataset.kvFrom || '0');
    const decimals = parseInt(el.dataset.kvDecimals || '0', 10);
    const duration = parseInt(el.dataset.kvDuration || '1600', 10);
    const suffix = el.dataset.kvSuffix || '';

    if (reduceMotion) {
      el.textContent = formatNumber(to, decimals) + suffix;
      return;
    }

    const start = performance.now();
    const tick = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = formatNumber(from + (to - from) * eased, decimals) + suffix;
      if (progress < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        el.classList.add('is-visible');
        if (el.dataset.kvCount !== undefined) countUp(el);
        observer.unobserve(el);
      });
    },
    { threshold: 0.2, rootMargin: '0px 0px -40px 0px' }
  );

  const init = (root = document) => {
    root.querySelectorAll('[data-kv-reveal], [data-kv-count], [data-kv-animate]').forEach((el) => {
      if (el.dataset.kvBound) return;
      el.dataset.kvBound = 'true';
      observer.observe(el);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
